module.exports = __webpack_public_path__ + "static/media/carousel-arrow-small-right.e9e114b2.svg";